export const appSave = (filter) => {
    return axios.post(`/chain/api/app`, { filter }).then(res => res.data);
}
export const appLoadInfo = (filter) => {
    return axios.get(`/chain/api/app`, { filter }).then(res => res.data);
}

export const appLogout = () => {
    return axios.post('/logout').then(res => res.data);
}

